Object.values(document.querySelectorAll('.sectionNavigation button.sectionNavigation-toggler')).forEach(button => {
  button.addEventListener('click', function () {
    button.closest('ul').classList.toggle('open');
  })
});
